import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Play } from 'lucide-react';

const TaxFreeRetireeExperts = () => {
  const videos = [
    {
      id: 'PXjB0BbfZoY',
      title: 'Tax Free Retiree Expert Video 1',
      thumbnail: `https://img.youtube.com/vi/PXjB0BbfZoY/maxresdefault.jpg`,
      url: 'https://youtu.be/PXjB0BbfZoY'
    },
    {
      id: 'b5g22OR5424',
      title: 'Tax Free Retiree Expert Video 2',
      thumbnail: `https://img.youtube.com/vi/b5g22OR5424/maxresdefault.jpg`,
      url: 'https://youtu.be/b5g22OR5424'
    },
    {
      id: '3uyXLn8ePWc',
      title: 'Tax Free Retiree Expert Video 3',
      thumbnail: `https://img.youtube.com/vi/3uyXLn8ePWc/maxresdefault.jpg`,
      url: 'https://youtu.be/3uyXLn8ePWc'
    },
    {
      id: '2pgldBE4Bj4',
      title: 'Tax Free Retiree Expert Video 4',
      thumbnail: `https://img.youtube.com/vi/2pgldBE4Bj4/maxresdefault.jpg`,
      url: 'https://youtu.be/2pgldBE4Bj4'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Excerpts from Dan's Show 'Tax Free Retiree'
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            RMD ages, contribution amounts and the tax table has changed since these recordings but the concepts are timeless.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {videos.map((video) => (
            <Card 
              key={video.id} 
              className="group cursor-pointer hover:shadow-lg transition-shadow duration-300"
              onClick={() => window.open(video.url, '_blank')}
            >
              <CardContent className="p-0">
                <AspectRatio ratio={16/9}>
                  <div className="relative w-full h-full overflow-hidden rounded-t-lg">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                      <Play className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" size={48} />
                    </div>
                  </div>
                </AspectRatio>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaxFreeRetireeExperts;